import AppStorage from './appStorage';
import CookieStorage from './cookieStorage';

const createVStorage = <T extends Storage>(storageInstance: T) => {
  const get: T['getItem'] = key => storageInstance.getItem(key);
  const set: T['setItem'] = (...params) => storageInstance.setItem(...params);
  const remove: T['removeItem'] = (...params) =>
    storageInstance.removeItem(...params);
  const clear: T['clear'] = (...params) => storageInstance.clear(...params);

  return {
    get,
    set,
    remove,
    clear,
  };
};

const VStorage = () => ({
  local: createVStorage(new AppStorage()),
  session: createVStorage(new AppStorage('session')),
  cookie: createVStorage(new CookieStorage()),
});

export default VStorage();
